import { render, staticRenderFns } from "./OctopusTransactions.vue?vue&type=template&id=17f1fd39"
import script from "./OctopusTransactions.vue?vue&type=script&lang=js"
export * from "./OctopusTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports